import { render } from "./OurClients.vue?vue&type=template&id=d6865b7c&ts=true"
import script from "./OurClients.vue?vue&type=script&lang=ts"
export * from "./OurClients.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__